import React from "react";
import { subColor } from "@/lib/risk";
import { EVIDENCE_CATEGORIES } from "@/lib/risk";
import { RotateCcw, MessageSquareWarning, CreditCard, Home, PartyPopper } from "lucide-react";

const ICONS = {
  refund_risk: RotateCcw,
  extortion_coercion_risk: MessageSquareWarning,
  chargeback_risk: CreditCard,
  property_damage_risk: Home,
  party_disturbance_risk: PartyPopper,
};

export const CategoryGrid = ({ categories }) => (
  <div data-testid="dashboard-category-grid">
    <h3 className="mb-3 font-display text-base font-semibold">Evidence risk categories</h3>
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-5">
      {EVIDENCE_CATEGORIES.map(({ key, label, short }) => {
        const c = categories?.[key] || { flagged: 0, high: 0, avg: 0 };
        const Icon = ICONS[key];
        return (
          <div key={key} className="rounded-xl border bg-card p-4" data-testid={`cat-card-${key}`}>
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium text-muted-foreground">{short}</span>
              <Icon className="h-4 w-4" style={{ color: subColor(c.avg) }} />
            </div>
            <p className="mt-2 font-display text-2xl font-semibold tabular-nums" data-testid={`cat-flagged-${key}`}>{c.flagged}</p>
            <p className="text-xs text-muted-foreground">flagged ({c.high} high)</p>
            <div className="mt-2 h-1.5 rounded-full bg-muted">
              <div className="h-full rounded-full" style={{ width: `${c.avg}%`, backgroundColor: subColor(c.avg) }} />
            </div>
            <p className="mt-1 text-[11px] text-muted-foreground">avg {c.avg}/100</p>
          </div>
        );
      })}
    </div>
  </div>
);
